/* Gastrolux option badges, while retaining exact Shopify option values */
(function(){
  function enhance(){
    document.querySelectorAll('.product-detail .options--diametre').forEach(list=>list.classList.toggle('gwe-diameter--compact',list.querySelectorAll(':scope > li').length<3));
    document.querySelectorAll('.product-detail .selector-wrapper[data-option-name]').forEach(wrapper=>{
      const type=wrapper.getAttribute('data-option-name')||'';
      const ul=wrapper.querySelector('.clickyboxes');
      if(!ul)return;
      if(/manche/i.test(type)){
        const template=wrapper.querySelector('[data-gwe-manche-saving]');
        for(const a of ul.querySelectorAll('a[data-value]')){
          const value=(a.dataset.value||'').toLowerCase();
          if(!a.querySelector('.gwe-manche-explainer')){
            let copy='';
            if(value.startsWith('fixe'))copy='Reste sur l’ustensile';
            else if(value.includes('amovible'))copy='Se clipse et se retire';
            else if(value.includes('sans manche'))copy='À compléter avec un manche';
            if(copy){const detail=document.createElement('span');detail.className='gwe-manche-explainer';detail.textContent=copy;a.appendChild(detail)}
          }
          if(/^Fixe \((Grand|Petit)\)$/i.test(a.dataset.value||'')){
            if(!a.dataset.gweLabelShortened){const detail=a.querySelector('.gwe-manche-explainer');a.textContent='Fixe';if(detail)a.appendChild(detail);a.dataset.gweLabelShortened='true'}
          }
          if(/sans manche/i.test(a.dataset.value||'')&&template&&!a.parentElement.querySelector('.gwe-variant-saving')){
            const badge=document.createElement('span');badge.className='gwe-variant-saving';badge.textContent='Vous économisez '+template.dataset.gweMancheSaving;a.parentElement.appendChild(badge);
          }
        }
      }
    });
  }
  let queued=false;
  function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;enhance()})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{enhance();observe()});else{enhance();observe()}
  function observe(){const el=document.querySelector('.product-area .product-detail__form__options');if(!el)return;new MutationObserver(schedule).observe(el,{childList:true,subtree:true});}
  document.addEventListener('shopify:section:load',schedule);
})();
